import SalesChannel from 'services/SalesChannel';
import { menuAccountTxt } from './translate/variables';
import React from 'react';

const api = {
    proxyV2: 'https://apijumboweb.smdigital.cl/proxy/api/v2',
    proxy: 'https://apijumboweb.smdigital.cl/proxy/api/v1',
    orderFormV2: 'https://apijumboweb.smdigital.cl/orderform/api/v2',
    orderForm: 'https://apijumboweb.smdigital.cl/orderform/api/v1',
    catalogV2: 'https://apijumboweb.smdigital.cl/catalog/api/v2',
    catalog: 'https://apijumboweb.smdigital.cl/catalog/api/v1',
    cms: 'https://apijumboweb.smdigital.cl/cms/api/v1',
    ordersV2: 'https://apijumboweb.smdigital.cl/orders/api/v2',
    ordersV3:  'https://apijumboweb.smdigital.cl/orders/api/v3',
    orders: 'https://apijumboweb.smdigital.cl/orders/api/v1',
    user: 'https://apijumboweb.smdigital.cl/user/api/v1',
    userAddress: 'https://apijumboweb.smdigital.cl/user/address/api/v1',
    userAddressV2: 'https://apijumboweb.smdigital.cl/user/address/api/v2',
    shoppingList: 'https://apijumboweb.smdigital.cl/shopping-list/api/v1',
    salesChannelV2: 'https://apijumboweb.smdigital.cl/sales-channel-geolocation/api/v2',
    salesChannel: 'https://apijumboweb.smdigital.cl/sales-channel-geolocation/api/v1',
    promotions: 'https://apijumboweb.smdigital.cl/promotions/api/v1',
    express: 'https://api.smdigital.cl:8443/v0/cl/juboAhoraWeb/proxy/CMS',
    searchV2: 'https://apijumboweb.smdigital.cl/search/api/v2',
    search: 'https://apijumboweb.smdigital.cl/search/api/v1',
    abandonedCart: 'https://apijumboweb.smdigital.cl/abandoned-cart/api/v1',
    wallet: 'https://apijumboweb.smdigital.cl/wallet/api/v1',
    transactionV1: 'https://apijumboweb.smdigital.cl/transaction/api/v1',
    transaction: 'https://apijumboweb.smdigital.cl/transaction/api/v2',
    headerNotifications: 'https://apijumboweb.smdigital.cl/notification/api/v1',
    chat: 'https://apijumboweb.smdigital.cl/chat/api/v1',
    apiKey: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
};

const assetsJson = 'https://apijumboweb.smdigital.cl/cms/api/v1/json';

const jsonData = {
    promotions: `${assetsJson}/promotions-v2.json`,
    categories: `${assetsJson}/categories.json`,
    cms: `${assetsJson}/cms`
}

const version = VERSION_ENV;

const maxItemsExpress = 180;

const basicPayload = {
    "orderItems": [],
    "expectedOrderFormSections": [
        "items",
        "totalizers",
        "clientProfileData",
        "shippingData",
        "paymentData",
        "sellers",
        "messages",
        "marketingData",
        "clientPreferencesData",
        "storePreferencesData",
        "giftRegistryData",
        "ratesAndBenefitsData",
        "openTextField",
        "commercialConditionData",
        "customData"
    ],
    "noSplitItem": true
};

const criterias = [
    {
        id: 6,
        index: 0,
        title: 'Criterio Jumbo',
        value: 'Criterio Jumbo',
        className: 'jumbo-icon-short-logo criterio-jumbo',
        info: <><ul><li className="cart-susbstitution-criterio-jumbo-info"><strong className="cart-substitution-info-title">¿Qué es el criterio Jumbo?</strong></li><li className="cart-susbstitution-criterio-jumbo-info"><i className="cart-substitution-criterio-jumbo-icon"></i>Ante un producto sin stock, buscaremos otro de reemplazo.</li><li className="cart-susbstitution-criterio-jumbo-info"><i className="cart-substitution-criterio-jumbo-icon"></i>Mantendremos la marca, pero en otro formato. </li><li className="cart-susbstitution-criterio-jumbo-info"><i className="cart-substitution-criterio-jumbo-icon"></i>Mantendremos características especiales (ligth, diet o sin lactosa).</li><li className="cart-susbstitution-criterio-jumbo-info"><i className="cart-substitution-criterio-jumbo-icon"></i>Si no encontramos el adecuado, buscaremos otra marca o sabor.</li></ul></>
    },
    {
        id: 2,
        index: 1,
        title: 'No sustituir',
        value: 'No sustituir',
        className: 'jumbo-icon-block',
        info: <><ul><li className="cart-susbstitution-criterio-jumbo-info"><i className="cart-substitution-criterio-jumbo-icon"></i>Si un producto no estuviera disponible, no será sustituido (<strong>ni cobrado</strong>), sin embargo si encontráramos un sustituo adecuado, te llamaremos para ofrecértelo como reemplazo.</li></ul></>
    }
];

const salesChannel = () => {
    return SalesChannel.getSalesChannel();
};

const nameSalesChannel = SalesChannel.getSalesChannelName();

const nameMethod = SalesChannel.getMethodName();

const sellerIdFood = "1";

const imageUrl = "https://jumbo.vteximg.com.br";
const defaultCategory = ["despensa"];

const googleMaps = {
    api: 'AIzaSyAZZRB2ULTJpGVsBPKhJ6VshxqKqA0hQ9Q',
    apiWithoutRestrictions: 'AIzaSyBwPqTrJhATFWl0INf5V2KhAjukgWib_Ws'
};

const rutRegex = /^[0-9]{1,2}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9Kk]{1}$/;

const tlfnRegex = /^[+]{0,1}[0-9]{9,11}$/;

const tlfnSmallRegex = /^[0-9]{8,10}$/;

const emailRegex = /^(([^<>()[\]\\.,;:ñáéíóúèàìòù´`$¢\s@"]+(\.[^<>()[\]\\.,;:ñáéíóúèàìòù`´$¢\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const maxItemsOSM = 60;

const catId = '560102';

const methodToSla = {
    'seller-1-sla-DespachoaDomicilio': 'Despacho a Domicilio',
    'seller-1-sla-RetiroenTienda': 'Retiro en Tienda',
    'seller-1-sla-ClickalAuto': 'Click al Auto',
    'seller-1-sla-Express': 'Express'
}

const salesChannelBO = [
    { "id": 11, "nombre": "La Reina" },
    { "id": 13, "nombre": "La Dehesa" },
    { "id": 18, "nombre": "La Florida" },
    { "id": 22, "nombre": "El llano" },
    { "id": 25, "nombre": "Maipu" },
    { "id": 28, "nombre": "Ñuñoa" },
    { "id": 31, "nombre": "Kennedy" },
    { "id": 32, "nombre": "Concha y toro" },
    { "id": 33, "nombre": "Los Dominicos" },
    { "id": 34, "nombre": "La Dehesa" },
    { "id": 35, "nombre": "Maipu" },
    { "id": 36, "nombre": "La Reina" },
    { "id": 37, "nombre": "Peñalolen" },
    { "id": 38, "nombre": "Independencia" },
    { "id": 39, "nombre":"costanera" },
    { "id": 40, "nombre":"San Bernardo" }
];

const expressFlag = false;
const notificationsFlag = true;
const firebaseAnalyticsFlag = true;
const withCriteria = false;
const hasPickingNightMessage = true;
const showTermsModal = true;
const withPersistentCart = true;
const paymentPromissory = false;
const paymentDebit = false;
const helpCenterFlag = true;
const orderTicketFlag = true;
const upsellingCMS = true;
const upsellingPersonalize = true;
const hasfrequentProductsFlag = true;
const paymentDebitWallet = true;
const jumboQAtransbank = false;
const chatOrdersFlag = false;
const shopTogetherFlag = true;

const paymentsId = {
    debit : "30",
    promissory : "203",
    oneClick : "201",
    catOneClick : "202",
    debitOneClick : "203"
};
const walletPaymentsName = {
    oneClick : 'OneClick',
    catOneClick : 'CATOneClick',
    debitOneClick: 'DebitoOneClick'
};
const paymentsName = {
    oneClick : 'JumboOneClick',
    catOneClick : 'CatOneClick',
    debitOneClick: 'DebitoOneClick'
};

const payments = [];

if(paymentDebit) payments.push({
    idVtex: paymentsId.debit,
    message: "",
    title: "Tarjeta de débito",
    subtitle:"Pagos y devoluciones operados por Mercado Pago"
});

if(paymentPromissory) payments.push({
    idVtex: paymentsId.promissory,
    message: "Paga con tu tarjeta de débito en el local al momento de retirar tu pedido",
    title: "Pago con débito en tienda",
    subtitle:''
});

let searchPagesRedirect = {
    'agenda hora local': '/informaciones/evita-la-fila',
    'agenda hora': '/informaciones/evita-la-fila',
    'agenda tu hora': '/informaciones/evita-la-fila',
    'agendar hora local': '/informaciones/evita-la-fila',
    'agendar hora': '/informaciones/evita-la-fila',
    'evita fila': '/informaciones/evita-la-fila',
    'evita la fila': '/informaciones/evita-la-fila',
    'locales': '/locales',
    'oferta': '/oferta/ofertas-fdm',
    'ofertas': '/oferta/ofertas-fdm',
    'pedir hora': '/informaciones/evita-la-fila',
    'reserva': '/informaciones/evita-la-fila',
    'reservar': '/informaciones/evita-la-fila',
    'tu hora': '/informaciones/evita-la-fila',
    'visita presencial': '/informaciones/evita-la-fila'
}

const dataUserMenu = [
    {"name": menuAccountTxt.info, "url": "/mis-datos"},
    {"name": menuAccountTxt.orders, "url": "/mis-compras"},
    {"name": menuAccountTxt.lists, "url": "/mis-listas-de-compras"},
    {"name": menuAccountTxt.cards, "url": "/mis-tarjetas"},
    {"name": menuAccountTxt.frequentProducts, "url": "/productos-frecuentes"},
    {"name": menuAccountTxt.favoriteProducts, "url": "/productos-favoritos"}
];
if(paymentDebitWallet){
    dataUserMenu.push({"name": menuAccountTxt.bank, "url": "/mi-cuenta-bancaria"})
}

const expressShipping = {
    maxQtyOfProducts: 35,
    closerWindow: 1000 * 60 * 150,
    timeLimitExpress: 1000 * 60 * 210,
}

const earlyCallTime = "09:59:59";

const typeAccount = [
    { label: 'CORRIENTE', value: 1 },
    { label: 'VISTA', value: 2 },
    { label: 'AHORRO', value: 3 },
    { label: 'RUT', value: 4 },
    { label: 'PREPAGO', value: 5 },
]

const minPurchasePrime = 30000;
const searchVariantID = 'P5d_1h4aSbWsKY0MLOu-Dg';
const sliderCartVariantID = 'ufa68wwlSr2hFPco9rijlw';

const campaignPersonalize = {
    pdpCampaign: 'pdp-recommendation',
    pdpFilterPack: 'pdp-recommendation-pack',
    pdpFilterSimilar: 'pdp-recommendation-category'
}

export {
    api,
    sellerIdFood,
    salesChannel,
    nameSalesChannel,
    nameMethod,
    imageUrl,
    defaultCategory,
    basicPayload,
    googleMaps,
    rutRegex,
    emailRegex,
    tlfnRegex,
    tlfnSmallRegex,
    maxItemsOSM,
    catId,
    maxItemsExpress,
    criterias,
    methodToSla,
    expressFlag,
    version,
    jsonData,
    notificationsFlag,
    salesChannelBO,
    withCriteria,
    hasPickingNightMessage,
    showTermsModal,
    firebaseAnalyticsFlag,
    withPersistentCart,
    paymentPromissory,
    payments,
    paymentsId,
    walletPaymentsName,
    paymentsName,
    searchPagesRedirect,
    helpCenterFlag,
    orderTicketFlag,
    expressShipping,
    upsellingCMS,
    upsellingPersonalize,
    earlyCallTime,
    hasfrequentProductsFlag,
    minPurchasePrime,
    paymentDebitWallet,
    typeAccount,
    dataUserMenu,
    jumboQAtransbank,
    chatOrdersFlag,
    campaignPersonalize,
    shopTogetherFlag,
    searchVariantID,
    sliderCartVariantID
};
